<template>
  <!-- EASAdvertiser -->
  <el-tab-pane label="EASAdvertiser">
    <div>
      <div class="row">
        <div class="col-sm-12">
          <el-card>
            <h4 style="color: #3b291d">EASAdvertiser =>
              <el-switch v-model="searchKeyConfig.SendDCName" class="ml-2" inline-prompt size="large"
                style="--el-switch-on-color:red ; --el-switch-off-color: blue" active-text="hk" active-value="hk"
                inactive-text="hktest" inactive-value="hktest" />
            </h4>
            <!-- Start search part -->

            <div class="row">
              <div class="col-sm-2">
                <base-input label="AdvertiserName">
                  <el-input placeholder="AdvertiserName" clearable style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    " v-model="searchKeyConfig.advertiserName"></el-input>
                </base-input>
              </div>
              <div class="col-sm-2">
                <base-input label="DcName" :clearable="true">
                  <el-select v-model="searchKeyConfig.dcName" class="select-primary" filterable size="large"
                    placeholder="DcName">
                    <el-option label="all" :value="null"> </el-option>
                    <el-option label="hk" value="hk"> </el-option>
                    <el-option label="hktest" value="hktest"> </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-sm-2">
                <base-input label="EASAdvertiserCodeIsNull" :clearable="true">
                  <el-select v-model="searchKeyConfig.easAdvertiserCodeIsNull" class="select-primary" filterable
                    size="large" placeholder="EASAdvertiserCodeIsNull">
                    <el-option label="All" :value="null"> </el-option>
                    <el-option label="IsNull" :value="true"> </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-sm-3">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    ">
                    <base-button type="primary" @click="searchConfig" style="width: 100px">Search</base-button>
                    <base-button type="primary" @click="resetConfig" style="width: 100px">Reset</base-button>
                    <base-button type="danger" @click="queryConfig" style="width: 100px">Query</base-button>
                  </div>
                </div>
              </div>
            </div>
            <!-- end Search part-->
            <div class="row" style="margin-top: 20px">
              <div class="col-sm-12" style="display: flex">
                <div class="col-sm-3">
                  <el-link type="primary" @click="OpenAddConfig">Add EASAdvertiser</el-link>

                </div>
                <span style="
                    margin-left: auto;
                    line-height: 32px;
                    padding-right: 20px;
                  ">
                  <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]" :small="small" :background="true"
                    layout="total, sizes, prev, pager, next, jumper" :total="searchKeyConfig.total"
                    @size-change="ChangePageSearchConfig" @current-change="ChangePageSearchConfig" />
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <el-table :data="Configlist" style="width: 100%" border header-row-class-name="header-row"
                  @filter-change="searchConfig" table-layout="auto" cell-class-name="report-cell">
                  <el-table-column prop="id" label="Id" v-if="false" />
                  <tablecolumn prop="dcName" label="DcName" :width="100" />
                  <tablecolumn prop="advertiserID" label="AdvertiserID" :width="300" />
                  <tablecolumn prop="advertiserCode" label="AdvertiserCode" :width="300" />
                  <tablecolumn prop="easAdvertiserCode" label="EASAdvertiserCode" :width="200" />
                  <tablecolumn prop="advertiserName" label="AdvertiserName" :width="250" />
                  <tablecolumn prop="easAdvertiserName" label="EASAdvertiserName" :width="200" />
                  <el-table-column prop="easReturnData" label="EASReturnData">
                    <template #default="scope">
                      <el-popover placement="right" :width="800" trigger="click">
                        <template #reference>
                          <el-button class="m-2">{{ scope.row.easReturnData != null ?
                            scope.row.easReturnData.substring(0,
                              50) : null }}</el-button>
                        </template>
                        <div style="overflow-y: auto; ">
                          <pre style="height: 600px; color: black;font-size: 16px;">{{ scope.row.easReturnData }}</pre>
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <tablecolumn prop="remark" label="Remark" :width="200" />
                  <el-table-column prop="cteateDate" :formatter="formatterCellDateTime" label="CteateDate"
                    :width="200" />
                  <el-table-column prop="updateDate" :formatter="formatterCellDateTime" label="UpdateDate"
                    :width="200" />
                  <el-table-column prop="" fixed="right" label="Action" :width="160" class-name="action">
                    <template #default="scope">
                      <el-link type="primary" @click="OpenUpdateConfig(scope.row)">Update</el-link>
                      <el-link style="margin-left: 20px;" type="danger"
                        @click="OpenDeleteConfig(scope.row)">Delete</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div></div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 添加Config -->
    <div>
      <el-dialog v-model="dialogFormOpenAddConfig" title="Add EASAdvertiser" :width="800">
        <el-form :model="ConfigInfoData">
          <el-form-item label="DcName" required :label-width="formLabelWidth">
            <el-select v-model="ConfigInfoData.value.dcName">
              <el-option label="hk" value="hk" />
              <el-option label="hktest" value="hktest" />
            </el-select>
          </el-form-item>

          <el-form-item label="AdvertiserID" required :label-width="formLabelWidth">
            <el-input v-model="ConfigInfoData.value.advertiserID" autocomplete="off" style="width: 400px;" />
          </el-form-item>

          <el-form-item label="AdvertiserCode" required :label-width="formLabelWidth">
            <el-input v-model="ConfigInfoData.value.advertiserCode" autocomplete="off" style="width: 400px;" />
          </el-form-item>

          <el-form-item label="EASAdvertiserCode" :label-width="formLabelWidth">
            <el-input v-model="ConfigInfoData.value.easAdvertiserCode" autocomplete="off" style="width: 400px;" />
          </el-form-item>

          <el-form-item label="AdvertiserName" required :label-width="formLabelWidth">
            <el-input type="textarea" v-model="ConfigInfoData.value.advertiserName" :autosize="{ minRows: 3 }"
              autocomplete="off" />
          </el-form-item>

          <el-form-item label="EASAdvertiserName" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="ConfigInfoData.value.easAdvertiserName" :autosize="{ minRows: 3 }"
              autocomplete="off" />
          </el-form-item>

          <el-form-item label="EASReturnData" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="ConfigInfoData.value.easReturnData" :autosize="{ minRows: 3 }"
              autocomplete="off" />
          </el-form-item>

          <el-form-item label="Remark" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="ConfigInfoData.value.remark" :autosize="{ minRows: 3 }"
              autocomplete="off" />
          </el-form-item>
        </el-form>

        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormOpenAddConfig = false">Cancel</el-button>
            <el-button type="primary" @click="AddConfigs"> Confirm </el-button>
          </span>
        </template>
      </el-dialog>
    </div>

    <div>
      <el-dialog v-model="dialogFormOpenEASAdvertiserList" title="EASAdvertiserList" :width="800">
        <!-- <el-input type="textarea" v-model="EASAdvertiserList" :autosize="{ minRows: 3 }" /> -->
        <div style="overflow-y: auto; ">
          <pre style="height: 600px; color: black;font-size: 16px;">{{ EASAdvertiserList }}</pre>
        </div>
      </el-dialog>
    </div>
  </el-tab-pane>
</template>

<script setup>
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import tablecolumn from '@/components/tablecolumn';
import PubSub from 'pubsub-js';

const formLabelWidth = '160px';
const currentPage = ref(1);
const pageSize = ref(10);
const EASAdvertiserList = ref("");

// router
import router from '@/router';
import profile from '@/network/profile';

// icon
import { Edit, Search } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';

// tool
import {
  formatterCellMoney,
  formatterCellDate,
  formatterCellDateTime,
} from '@/assets/js/formatter';
onBeforeMount(async () => {
  await searchConfig();
});

//#region Configs
const Configlist = ref([]);
const dialogFormOpenAddConfig = ref(false);
const dialogFormOpenUpdateConfig = ref(false);
const dialogFormOpenEASAdvertiserList = ref(false);
const ConfigInfoData = reactive({});
const userlist = ref([]);

//变更分页
const ChangePageSearchConfig = async (data) => {
  searchKeyConfig.pageIndex = currentPage;
  searchKeyConfig.pageSize = pageSize;
  searchConfig();
};
const searchKeyConfig = reactive({
  pageIndex: 1,
  pageSize: 10,
  SendDCName: 'hktest',
});

const searchConfig = async () => {
  const search_res = await profile
    .GetEASAdvertiserList(searchKeyConfig)
    .then((res) => res);
  searchKeyConfig.total = search_res.data.total;
  Configlist.value = search_res.data.list;
  // userlist.value = search_res.data.userlist;
};

const resetConfig = async () => {
  //清空对象
  Object.keys(searchKeyConfig).map((key) => {
    if (key != 'SendDCName') {
      delete searchKeyConfig[key];
    }
  });
  searchKeyConfig.pageIndex = 1;
  searchKeyConfig.pageSize = 10;
  searchConfig();
};
//查询客户资料
const queryConfig = async () => {
  const search_res = await profile
    .GetAdvertiserListInEAS(searchKeyConfig)
    .then((res) => res);
  // EASAdvertiserList.value = JSON.stringify(search_res.data);
  EASAdvertiserList.value = search_res.data;
  console.log(111, EASAdvertiserList, search_res, JSON.stringify(EASAdvertiserList.value));
  dialogFormOpenEASAdvertiserList.value = true;
};
//打开添加Config
const OpenAddConfig = async (data) => {
  dialogFormOpenAddConfig.value = true;
  ConfigInfoData.value = {};
};

//打开修改窗口
const OpenUpdateConfig = async (data) => {
  dialogFormOpenAddConfig.value = true;
  ConfigInfoData.value = JSON.parse(JSON.stringify(data));
};
//添加Config
const AddConfigs = async (data) => {
  const result = await profile
    .AddUpdateEASAdvertiser(ConfigInfoData.value)
    .then((res) => res);
  if (result.data === '') {
    dialogFormOpenAddConfig.value = false;
    ElMessage({
      message: '操作成功',
      type: 'success',
    });
  } else {
    ElMessage({
      message: result.data,
      type: 'warning',
    });
    return;
  }
  await searchConfig();
};

//删除
const OpenDeleteConfig = async (data) => {
  ConfigInfoData.value = data;
  ElMessageBox.confirm(
    'Are you sure to delete (' + data.name + ')?',
    'Warning',
    {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
    }
  )
    .then(async () => {
      const result = await profile
        .DeleteEASAdvertiser(ConfigInfoData.value)
        .then((res) => res);
      if (result.data === '') {
        ElMessage({
          message: '删除成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
      await searchConfig();
    })
    .catch(() => { });
};
//#endregion

//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    searchKeyConfig[`${data.key}`] = data.value;
    searchConfig();
  });
});
</script>

<style scoped>
.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
